module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/txt-result-e1811962a1b71fa36bd17dc943d5da51.png";